/**
 * The engine's one error helper, moved from apps/web/src/lib/errors.ts with the
 * closure (#183). Kept as its own module rather than inlined so the browser
 * copy can re-export it and there is no second implementation.
 */
export function errMsg(e: unknown): string {
  return e instanceof Error ? e.message : String(e);
}
